<div *appIsDesktop>
  <h1 mat-dialog-title>{{data.title}}</h1>
  <div mat-dialog-content [innerHTML]="data.content"></div>
  <div mat-dialog-actions class="dialog-button-container">
    @for (button of data.buttons; track button; let i = $index) {
      <button id="dialogButton_{{i}}" mat-button class="button" [ngClass]="button.style" (click)="btnCallback(i)"
        [attr.cdkFocusInitial]="button.focused ? '' : null">
        @if (button.icon) {
          <span class="crm-industrial-font" [ngClass]="button.icon"></span>
        }
        <span>{{button.label}}</span>
      </button>
    }
  </div>
</div>

<div *appIsMobile>
  <div mat-dialog-title class="title ds">
    <span>{{data.title}}</span>
    @if (!data.disableClose) {
      <button mat-icon-button class="close-dialog-button" mat-dialog-close>
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    }
  </div>
  <div mat-dialog-content class="content ds">
    <div [ngClass]="{'mandatory-label': mandatory}" [innerHTML]="data.content"></div>
  </div>
  <div mat-dialog-actions align="end" class="ds">
    <div class="dialog-btn-wrapper">
      @for (button of data.buttons; track button; let i = $index) {
        <ds-button id="dialogButton_{{i}}" variant="label-only" size="medium"
          [type]="button.style" (onClick)="btnCallback(i)" [label]="button.label">
        </ds-button>
      }
    </div>
  </div>
</div>
